import { PATHNAMES } from 'utils/routes/consts'

export const pathsToShowNavigationBar = [
  PATHNAMES.WORKSPACE_DASHBOARDS,
  PATHNAMES.DASHBOARDS,
  PATHNAMES.OUTDATED_WORKSPACE_CATEGORY,
  PATHNAMES.WORKSPACE_SOA,
  PATHNAMES.WORKSPACE_ZAI,
  PATHNAMES.WORKSPACE_ZAI_ANSWER,
]

export const pathsToHideNavigationBar = [
  PATHNAMES.OUTDATED_WORKSPACE_CATEGORY_RANKING,
  PATHNAMES.WORKSPACE_SOA_RANKING,
  PATHNAMES.WORKSPACE_ZAI_ANSWER,
  PATHNAMES.ONBOARDING,
  PATHNAMES.GETTING_STARTED,
]
